var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "upvote",
      class: {
        "upvote-voted": _vm.isVoted && !_vm.isDisabled,
        "upvote-disabled": _vm.isDisabled,
        "upvote-type-inline": _vm.isInline
      },
      attrs: { href: "upvoteUrl" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.toggle($event)
        }
      }
    },
    [_vm._v("\n    " + _vm._s(_vm.upvotes) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }